document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    document.querySelectorAll('.swiper-slider').forEach(slider => {
        new Swiper(slider, Object.assign({}, defaulsettings, slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {}));
    });

    let sliderImages = new Swiper(".swiper-slider-images", {
        loop: true,
        speed: 700,
        slidesPerView: 1,
        navigation: {
            prevEl: '.swiper-slider-prev',
            nextEl: '.swiper-slider-next'
        },
        allowTouchMove: false,
        breakpoints: {
            901: {
                slidesPerView: 2
            }
        }
    });

    let sliderCopy = new Swiper(".swiper-slider-copy", {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.swiper-slider-prev',
            nextEl: '.swiper-slider-next'
        },
        allowTouchMove: false
    });

    let sliderCards = new Swiper(".swiper-cards-quad", {
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: "3.4%",
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1200: {
                slidesPerView: 3
            }
        }
    });
});